import { render, staticRenderFns } from "./InactiveSourceCard.vue?vue&type=template&id=176aaf0c&scoped=true"
import script from "./InactiveSourceCard.vue?vue&type=script&lang=js"
export * from "./InactiveSourceCard.vue?vue&type=script&lang=js"
import style0 from "./InactiveSourceCard.vue?vue&type=style&index=0&id=176aaf0c&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "176aaf0c",
  null
  
)

export default component.exports